import { Button } from "@/ui/components/ui/button.tsx";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation("common");

  return (
    <div className="flex flex-col items-center justify-center h-full text-center py-20">
      <h1 className="text-3xl font-bold mb-4">{t("notFound.title")}</h1>
      <p className="text-gray-400 mb-6 max-w-md">
        {t("notFound.description")}
      </p>
      <Button>
        {t("notFound.action")}
      </Button>
    </div>
  );
}

export default NotFound;